
// SELECT id,klient_id,klient,firma_nazwa,data_spedycji,etap,przeloty_druku,przeloty_druku_zakonczone,do_wydrukowania,przeloty_falc,przeloty_falc_zakonczone,do_sfalcowania,wydrukowano_procent FROM artdruk.view_zamowienia_kalendarz;

export const daneTestowe = [
	{
		"id" : 337,
		"klient_id" : 82,
		"klient" : "BOOKOLIKA SP. Z O.O.",
		"firma_nazwa" : "BOOKOLIKA",
		"data_spedycji" : "2026-03-13",
		"etap" : 2,
		"przeloty_druku" : 35620,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 35620,
		"przeloty_falc" : 30000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 30000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 524,
		"klient_id" : 146,
		"klient" : "BAKS Kazimierz Sielski",
		"firma_nazwa" : "BAKS",
		"data_spedycji" : "2026-03-06",
		"etap" : 2,
		"przeloty_druku" : 391145,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 391145,
		"przeloty_falc" : 350000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 350000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1181,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-23",
		"etap" : 2,
		"przeloty_druku" : 616900,
		"przeloty_druku_zakonczone" : 610150,
		"do_wydrukowania" : 6750,
		"przeloty_falc" : 600000,
		"przeloty_falc_zakonczone" : 200000,
		"do_sfalcowania" : 400000,
		"wydrukowano_procent" : 99
	},
	{
		"id" : 1256,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-25",
		"etap" : 2,
		"przeloty_druku" : 37680,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 37680,
		"przeloty_falc" : 35200,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 35200,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1260,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-20",
		"etap" : 2,
		"przeloty_druku" : 68420,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 68420,
		"przeloty_falc" : 70000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 70000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1261,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-20",
		"etap" : 2,
		"przeloty_druku" : 150700,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 150700,
		"przeloty_falc" : 140000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 140000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1267,
		"klient_id" : 82,
		"klient" : "BOOKOLIKA SP. Z O.O.",
		"firma_nazwa" : "BOOKOLIKA",
		"data_spedycji" : "2026-02-27",
		"etap" : 2,
		"przeloty_druku" : 19250,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 19250,
		"przeloty_falc" : 20000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 20000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1268,
		"klient_id" : 114,
		"klient" : "SDWPRASA JOANNA SADOWSKA ",
		"firma_nazwa" : "SDW",
		"data_spedycji" : "2026-02-27",
		"etap" : 2,
		"przeloty_druku" : 8113,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 8113,
		"przeloty_falc" : 6050,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 6050,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1277,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-25",
		"etap" : 2,
		"przeloty_druku" : 50700,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 50700,
		"przeloty_falc" : 45000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 45000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1279,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-18",
		"etap" : 2,
		"przeloty_druku" : 45230,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 45230,
		"przeloty_falc" : 40000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 40000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1284,
		"klient_id" : 11,
		"klient" : "Marine Consulting",
		"firma_nazwa" : "Marine Consulting",
		"data_spedycji" : "2026-02-23",
		"etap" : 2,
		"przeloty_druku" : 5945,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 5945,
		"przeloty_falc" : 4200,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 4200,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1292,
		"klient_id" : 1,
		"klient" : "DESA Unicum",
		"firma_nazwa" : "DESA",
		"data_spedycji" : "2026-02-18",
		"etap" : 2,
		"przeloty_druku" : 19920,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 19920,
		"przeloty_falc" : 14400,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 14400,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1153,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-02",
		"etap" : 3,
		"przeloty_druku" : 396340,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 396340,
		"przeloty_falc" : 360000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 360000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1290,
		"klient_id" : 57,
		"klient" : "Macmillan Polska Sp. z o.o.",
		"firma_nazwa" : "Macmillan",
		"data_spedycji" : "2026-03-12",
		"etap" : 3,
		"przeloty_druku" : 113700,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 113700,
		"przeloty_falc" : 105000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 105000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1291,
		"klient_id" : 57,
		"klient" : "Macmillan Polska Sp. z o.o.",
		"firma_nazwa" : "Macmillan",
		"data_spedycji" : "2026-02-26",
		"etap" : 3,
		"przeloty_druku" : 61610,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 61610,
		"przeloty_falc" : 52000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 52000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1167,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-04-09",
		"etap" : 4,
		"przeloty_druku" : 97560,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 97560,
		"przeloty_falc" : 89600,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 89600,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1232,
		"klient_id" : 75,
		"klient" : "PRÓSZYŃSKI MEDIA sp. z o.o.",
		"firma_nazwa" : "PRÓSZYŃSKI",
		"data_spedycji" : "2026-02-23",
		"etap" : 4,
		"przeloty_druku" : 47182,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 47182,
		"przeloty_falc" : 42135,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 42135,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1247,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-13",
		"etap" : 4,
		"przeloty_druku" : 105550,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 105550,
		"przeloty_falc" : 96000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 96000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1253,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-03-13",
		"etap" : 4,
		"przeloty_druku" : 30140,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 30140,
		"przeloty_falc" : 0,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1273,
		"klient_id" : 55,
		"klient" : "AgroHorti Media Sp. z o.o.",
		"firma_nazwa" : "AgroHorti",
		"data_spedycji" : "2026-02-23",
		"etap" : 4,
		"przeloty_druku" : 4811,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 4811,
		"przeloty_falc" : 4200,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 4200,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1274,
		"klient_id" : 106,
		"klient" : "Awenta E.W.A. Chomka Sp. J.",
		"firma_nazwa" : "Awenta",
		"data_spedycji" : "2026-02-23",
		"etap" : 4,
		"przeloty_druku" : 15340,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 15340,
		"przeloty_falc" : 12000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 12000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1275,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-04-15",
		"etap" : 4,
		"przeloty_druku" : 168830,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 168830,
		"przeloty_falc" : 168700,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 168700,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1276,
		"klient_id" : 109,
		"klient" : "Preston Sp. z o.o.",
		"firma_nazwa" : "PRESTON",
		"data_spedycji" : "2026-03-04",
		"etap" : 4,
		"przeloty_druku" : 542850,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 542850,
		"przeloty_falc" : 1200000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 1200000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1278,
		"klient_id" : 109,
		"klient" : "Preston Sp. z o.o.",
		"firma_nazwa" : "PRESTON",
		"data_spedycji" : "2026-03-02",
		"etap" : 4,
		"przeloty_druku" : 130400,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 130400,
		"przeloty_falc" : 28,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 28,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1289,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-26",
		"etap" : 4,
		"przeloty_druku" : 164220,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 164220,
		"przeloty_falc" : 152000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 152000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 986,
		"klient_id" : 180,
		"klient" : "STURMER MASZYNY Sp. z o.o.",
		"firma_nazwa" : "STURMER",
		"data_spedycji" : "2026-02-17",
		"etap" : 6,
		"przeloty_druku" : 430760,
		"przeloty_druku_zakonczone" : 304040,
		"do_wydrukowania" : 126720,
		"przeloty_falc" : 410000,
		"przeloty_falc_zakonczone" : 200000,
		"do_sfalcowania" : 210000,
		"wydrukowano_procent" : 71
	},
	{
		"id" : 990,
		"klient_id" : 2,
		"klient" : "Realise",
		"firma_nazwa" : "Realise",
		"data_spedycji" : "2026-02-18",
		"etap" : 6,
		"przeloty_druku" : 240350,
		"przeloty_druku_zakonczone" : 7500,
		"do_wydrukowania" : 232850,
		"przeloty_falc" : 234000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 234000,
		"wydrukowano_procent" : 4
	},
	{
		"id" : 1178,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-24",
		"etap" : 6,
		"przeloty_druku" : 154250,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 154250,
		"przeloty_falc" : 150000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 150000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1231,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-02-19",
		"etap" : 6,
		"przeloty_druku" : 539050,
		"przeloty_druku_zakonczone" : 259500,
		"do_wydrukowania" : 279550,
		"przeloty_falc" : 525000,
		"przeloty_falc_zakonczone" : 75000,
		"do_sfalcowania" : 450000,
		"wydrukowano_procent" : 49
	},
	{
		"id" : 1266,
		"klient_id" : 65,
		"klient" : "Wojskowy Instytut Wydawniczy w Warszawie",
		"firma_nazwa" : "WIW",
		"data_spedycji" : "2026-02-20",
		"etap" : 6,
		"przeloty_druku" : 2400,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 2400,
		"przeloty_falc" : 2000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 2000,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1271,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-19",
		"etap" : 6,
		"przeloty_druku" : 9760,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 9760,
		"przeloty_falc" : 7700,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 7700,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1285,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-19",
		"etap" : 6,
		"przeloty_druku" : 5940,
		"przeloty_druku_zakonczone" : 0,
		"do_wydrukowania" : 5940,
		"przeloty_falc" : 3600,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 3600,
		"wydrukowano_procent" : 0
	},
	{
		"id" : 1272,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-18",
		"etap" : 7,
		"przeloty_druku" : 45300,
		"przeloty_druku_zakonczone" : 11400,
		"do_wydrukowania" : 33900,
		"przeloty_falc" : 42000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 42000,
		"wydrukowano_procent" : 26
	},
	{
		"id" : 1286,
		"klient_id" : 138,
		"klient" : "PRACOWNIA C C Sp. z o.o.",
		"firma_nazwa" : "PRACOWNIA C C",
		"data_spedycji" : "2026-02-17",
		"etap" : 7,
		"przeloty_druku" : 5250,
		"przeloty_druku_zakonczone" : 800,
		"do_wydrukowania" : 4450,
		"przeloty_falc" : 3800,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 3800,
		"wydrukowano_procent" : 16
	},
	{
		"id" : 1179,
		"klient_id" : 159,
		"klient" : "Miłosz Łuniewski",
		"firma_nazwa" : "Miłosz Łuniewski",
		"data_spedycji" : "2026-01-22",
		"etap" : 8,
		"przeloty_druku" : 6800,
		"przeloty_druku_zakonczone" : 6800,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 0,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1216,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-19",
		"etap" : 8,
		"przeloty_druku" : 61290,
		"przeloty_druku_zakonczone" : 61290,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 61000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 61000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1220,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-19",
		"etap" : 8,
		"przeloty_druku" : 159900,
		"przeloty_druku_zakonczone" : 159900,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 145000,
		"przeloty_falc_zakonczone" : 135000,
		"do_sfalcowania" : 10000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1245,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-18",
		"etap" : 8,
		"przeloty_druku" : 69940,
		"przeloty_druku_zakonczone" : 69940,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 65000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 65000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1254,
		"klient_id" : 206,
		"klient" : "Teatr im. St. I. Witkiewicza",
		"firma_nazwa" : "TEATR WITKIEWICZA",
		"data_spedycji" : "2026-02-20",
		"etap" : 8,
		"przeloty_druku" : 4475,
		"przeloty_druku_zakonczone" : 4475,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 3000,
		"przeloty_falc_zakonczone" : 500,
		"do_sfalcowania" : 2500,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1255,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-13",
		"etap" : 8,
		"przeloty_druku" : 9880,
		"przeloty_druku_zakonczone" : 9880,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 9600,
		"przeloty_falc_zakonczone" : 4800,
		"do_sfalcowania" : 4800,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1258,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-02-17",
		"etap" : 8,
		"przeloty_druku" : 31810,
		"przeloty_druku_zakonczone" : 31810,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 26500,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 26500,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1264,
		"klient_id" : 73,
		"klient" : "AUDIO-PROJEKT Arkadiusz Kulpa",
		"firma_nazwa" : "AUDIO-PROJEKT",
		"data_spedycji" : "2026-02-16",
		"etap" : 8,
		"przeloty_druku" : 16900,
		"przeloty_druku_zakonczone" : 16900,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 15120,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 15120,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1265,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-02-16",
		"etap" : 8,
		"przeloty_druku" : 15200,
		"przeloty_druku_zakonczone" : 15200,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 12900,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 12900,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1269,
		"klient_id" : 55,
		"klient" : "AgroHorti Media Sp. z o.o.",
		"firma_nazwa" : "AgroHorti",
		"data_spedycji" : "2026-02-17",
		"etap" : 8,
		"przeloty_druku" : 47070,
		"przeloty_druku_zakonczone" : 47070,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 42000,
		"przeloty_falc_zakonczone" : 0,
		"do_sfalcowania" : 42000,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1121,
		"klient_id" : 55,
		"klient" : "AgroHorti Media Sp. z o.o.",
		"firma_nazwa" : "AgroHorti",
		"data_spedycji" : "2026-01-19",
		"etap" : 10,
		"przeloty_druku" : 23810,
		"przeloty_druku_zakonczone" : 23810,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 22000,
		"przeloty_falc_zakonczone" : 22000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1123,
		"klient_id" : 57,
		"klient" : "Macmillan Polska Sp. z o.o.",
		"firma_nazwa" : "Macmillan",
		"data_spedycji" : "2026-02-18",
		"etap" : 10,
		"przeloty_druku" : 354380,
		"przeloty_druku_zakonczone" : 354380,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 342000,
		"przeloty_falc_zakonczone" : 342000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1132,
		"klient_id" : 157,
		"klient" : "Wydawnictwo „TALES” Krzysztof Konkel",
		"firma_nazwa" : "TALES Konkel",
		"data_spedycji" : "2026-02-02",
		"etap" : 10,
		"przeloty_druku" : 56160,
		"przeloty_druku_zakonczone" : 56160,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 50000,
		"przeloty_falc_zakonczone" : 50000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1133,
		"klient_id" : 156,
		"klient" : "Wydawnictwo „TALES” Marek Doliński",
		"firma_nazwa" : "TALES Doliński",
		"data_spedycji" : "2026-02-02",
		"etap" : 10,
		"przeloty_druku" : 56160,
		"przeloty_druku_zakonczone" : 56160,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 50000,
		"przeloty_falc_zakonczone" : 50000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1134,
		"klient_id" : 156,
		"klient" : "Wydawnictwo „TALES” Marek Doliński",
		"firma_nazwa" : "TALES Doliński",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 64480,
		"przeloty_druku_zakonczone" : 64480,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60000,
		"przeloty_falc_zakonczone" : 60000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1135,
		"klient_id" : 157,
		"klient" : "Wydawnictwo „TALES” Krzysztof Konkel",
		"firma_nazwa" : "TALES Konkel",
		"data_spedycji" : "2026-02-09",
		"etap" : 10,
		"przeloty_druku" : 64480,
		"przeloty_druku_zakonczone" : 64480,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60000,
		"przeloty_falc_zakonczone" : 60000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1147,
		"klient_id" : 199,
		"klient" : "300GOSPODARKA Sp. z o.o.",
		"firma_nazwa" : "300GOSPODARKA",
		"data_spedycji" : "2026-01-23",
		"etap" : 10,
		"przeloty_druku" : 9620,
		"przeloty_druku_zakonczone" : 9620,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 8000,
		"przeloty_falc_zakonczone" : 8000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1164,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 81390,
		"przeloty_druku_zakonczone" : 81390,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 74400,
		"przeloty_falc_zakonczone" : 74400,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1166,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 37260,
		"przeloty_druku_zakonczone" : 37260,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 32400,
		"przeloty_falc_zakonczone" : 32400,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1169,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-16",
		"etap" : 10,
		"przeloty_druku" : 84200,
		"przeloty_druku_zakonczone" : 84200,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 77000,
		"przeloty_falc_zakonczone" : 77000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1207,
		"klient_id" : 48,
		"klient" : "Instytut Zarządzania Informacją Sp. zoo",
		"firma_nazwa" : "IZI",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 67720,
		"przeloty_druku_zakonczone" : 67720,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 60890,
		"przeloty_falc_zakonczone" : 60890,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1217,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-19",
		"etap" : 10,
		"przeloty_druku" : 116220,
		"przeloty_druku_zakonczone" : 116220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 105000,
		"przeloty_falc_zakonczone" : 105000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1221,
		"klient_id" : 80,
		"klient" : "Wydawnictwa Komunikacji i Łączności ",
		"firma_nazwa" : "WKL",
		"data_spedycji" : "2026-02-12",
		"etap" : 10,
		"przeloty_druku" : 11680,
		"przeloty_druku_zakonczone" : 11680,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 9000,
		"przeloty_falc_zakonczone" : 9000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1222,
		"klient_id" : 202,
		"klient" : "H2 Dystrybucja sp zoo",
		"firma_nazwa" : "H2",
		"data_spedycji" : "2026-02-12",
		"etap" : 10,
		"przeloty_druku" : 153310,
		"przeloty_druku_zakonczone" : 153310,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 137750,
		"przeloty_falc_zakonczone" : 137750,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1223,
		"klient_id" : 45,
		"klient" : "KLETT POLSKA SPZOO",
		"firma_nazwa" : "Klett",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 62490,
		"przeloty_druku_zakonczone" : 62490,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 77000,
		"przeloty_falc_zakonczone" : 77000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1226,
		"klient_id" : 107,
		"klient" : "Nowa Era Sp. z o.o.",
		"firma_nazwa" : "Nowa Era",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 45280,
		"przeloty_druku_zakonczone" : 45280,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 40000,
		"przeloty_falc_zakonczone" : 40000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1234,
		"klient_id" : 71,
		"klient" : "Stowarzyszenie Filmowców Polskich",
		"firma_nazwa" : "SFP",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 14320,
		"przeloty_druku_zakonczone" : 14320,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 13200,
		"przeloty_falc_zakonczone" : 13200,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1238,
		"klient_id" : 44,
		"klient" : "Fischer Trading Group Sp. z o.o.",
		"firma_nazwa" : "Fischer Trading",
		"data_spedycji" : "2026-02-10",
		"etap" : 10,
		"przeloty_druku" : 488450,
		"przeloty_druku_zakonczone" : 488450,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 459000,
		"przeloty_falc_zakonczone" : 459000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1240,
		"klient_id" : 51,
		"klient" : "VFP Communications Ltd. Sp. z o. o.",
		"firma_nazwa" : "VFP",
		"data_spedycji" : "2026-02-13",
		"etap" : 10,
		"przeloty_druku" : 174010,
		"przeloty_druku_zakonczone" : 174010,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 160000,
		"przeloty_falc_zakonczone" : 160000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1248,
		"klient_id" : 118,
		"klient" : "Solmedia Urszula Kaszubowska",
		"firma_nazwa" : "Solmedia",
		"data_spedycji" : "2026-02-12",
		"etap" : 10,
		"przeloty_druku" : 20050,
		"przeloty_druku_zakonczone" : 20050,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 16800,
		"przeloty_falc_zakonczone" : 16800,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 936,
		"klient_id" : 138,
		"klient" : "PRACOWNIA C C Sp. z o.o.",
		"firma_nazwa" : "PRACOWNIA C C",
		"data_spedycji" : "2025-11-25",
		"etap" : 11,
		"przeloty_druku" : 59335,
		"przeloty_druku_zakonczone" : 59335,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 55500,
		"przeloty_falc_zakonczone" : 55500,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 974,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 41240,
		"przeloty_druku_zakonczone" : 41240,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 36000,
		"przeloty_falc_zakonczone" : 36000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 975,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 61340,
		"przeloty_druku_zakonczone" : 61340,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 54000,
		"przeloty_falc_zakonczone" : 54000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1003,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 84755,
		"przeloty_druku_zakonczone" : 84755,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 75300,
		"przeloty_falc_zakonczone" : 75300,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1007,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-08",
		"etap" : 11,
		"przeloty_druku" : 84755,
		"przeloty_druku_zakonczone" : 84755,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 75300,
		"przeloty_falc_zakonczone" : 75300,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1084,
		"klient_id" : 62,
		"klient" : "WSIP S.A.",
		"firma_nazwa" : "WSIP",
		"data_spedycji" : "2026-01-14",
		"etap" : 11,
		"przeloty_druku" : 180060,
		"przeloty_druku_zakonczone" : 180060,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 154000,
		"przeloty_falc_zakonczone" : 154000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1111,
		"klient_id" : 63,
		"klient" : "Medical Tribune Polska Sp. z o.o.",
		"firma_nazwa" : "Medical Trib",
		"data_spedycji" : "2026-01-15",
		"etap" : 11,
		"przeloty_druku" : 4220,
		"przeloty_druku_zakonczone" : 4220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 2700,
		"przeloty_falc_zakonczone" : 2700,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1117,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-01-14",
		"etap" : 11,
		"przeloty_druku" : 6220,
		"przeloty_druku_zakonczone" : 6220,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 5000,
		"przeloty_falc_zakonczone" : 5000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1186,
		"klient_id" : 80,
		"klient" : "Wydawnictwa Komunikacji i Łączności ",
		"firma_nazwa" : "WKL",
		"data_spedycji" : "2026-02-05",
		"etap" : 11,
		"przeloty_druku" : 41675,
		"przeloty_druku_zakonczone" : 41675,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 42000,
		"przeloty_falc_zakonczone" : 42000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1205,
		"klient_id" : 49,
		"klient" : "VIRIDIA AB SP.Z O.O.",
		"firma_nazwa" : "VIRIDIA",
		"data_spedycji" : "2026-02-03",
		"etap" : 11,
		"przeloty_druku" : 5960,
		"przeloty_druku_zakonczone" : 5960,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 10000,
		"przeloty_falc_zakonczone" : 10000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1211,
		"klient_id" : 189,
		"klient" : "Europrint Media Andrzej Oset",
		"firma_nazwa" : "Europrint ",
		"data_spedycji" : "2026-02-13",
		"etap" : 11,
		"przeloty_druku" : 17333,
		"przeloty_druku_zakonczone" : 17333,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 17500,
		"przeloty_falc_zakonczone" : 17500,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1233,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-02-09",
		"etap" : 11,
		"przeloty_druku" : 21420,
		"przeloty_druku_zakonczone" : 21420,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 16560,
		"przeloty_falc_zakonczone" : 16560,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1243,
		"klient_id" : 44,
		"klient" : "Fischer Trading Group Sp. z o.o.",
		"firma_nazwa" : "Fischer Trading",
		"data_spedycji" : "2026-02-11",
		"etap" : 11,
		"przeloty_druku" : 5400,
		"przeloty_druku_zakonczone" : 5400,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 15000,
		"przeloty_falc_zakonczone" : 15000,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	},
	{
		"id" : 1259,
		"klient_id" : 69,
		"klient" : "AVT- Korporacja Sp z o.o.",
		"firma_nazwa" : "AVT",
		"data_spedycji" : "2026-02-13",
		"etap" : 11,
		"przeloty_druku" : 7400,
		"przeloty_druku_zakonczone" : 7400,
		"do_wydrukowania" : 0,
		"przeloty_falc" : 5300,
		"przeloty_falc_zakonczone" : 5300,
		"do_sfalcowania" : 0,
		"wydrukowano_procent" : 100
	}
]
